module.exports.TRANSACTIONS_CONSTANT = {
    TRANSACTION_TYPE: {
        PURCHASE: 'purchase',
        REDEEM: 'free_good',
    },
    TRANSACTION_STATUS: {
        PENDING: 'pending',
        APPROVED: 'approved',
        DISAPPROVED: 'disapproved',
        VOIDED: 'voided',
    },
};
